import { render, staticRenderFns } from "./DevolucaoMovimentacaoSimplificadaList.vue?vue&type=template&id=9e346022"
import script from "./DevolucaoMovimentacaoSimplificadaList.vue?vue&type=script&lang=js"
export * from "./DevolucaoMovimentacaoSimplificadaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports